import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoPipe, translate } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';

/** Shared action row: play/continue, record, reminder, watch-later and the share menu. PrimeNG. */
@Component({
    selector: 'details-actions',
    standalone: true,
    imports: [ButtonModule, MenuModule, TranslocoPipe],
    templateUrl: './details-actions.html',
    styleUrl: './details-actions.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsActions {
    readonly showPlay = input(false);
    readonly playLabel = input('');
    readonly canRecord = input(false);
    readonly recorded = input(false);
    readonly canWatchLater = input(false);
    readonly watchLater = input(false);

    readonly play = output<void>();
    readonly record = output<void>();
    readonly remind = output<void>();
    readonly toggleWatchLater = output<void>();
    readonly share = output<string>();

    protected readonly shareItems: MenuItem[] = [
        { label: translate('share.facebook'), icon: 'pi pi-facebook', command: () => this.share.emit('facebook') },
        { label: translate('share.twitter'), icon: 'pi pi-twitter', command: () => this.share.emit('twitter') },
        { label: translate('share.email'), icon: 'pi pi-envelope', command: () => this.share.emit('email') },
        { label: translate('share.copy_link'), icon: 'pi pi-link', command: () => this.share.emit('copy') },
    ];
}
